import React from "react"
import { StyledHeadline } from "./style"

const Headline = ({ children, ...rest }: any) => {
  return <StyledHeadline {...rest}>{children}</StyledHeadline>
}

export default Headline
